import { Skeleton } from '@payler/ui-components';
import { FC } from 'react';

export const FieldSkeleton: FC = () => (
  <Skeleton w="100%" h={7} rounded={1.5} />
);
